<template>
  <div id="legal-notices">
    <section class="introduction">
      <div class="container">
        <div class="columns">
          <div class="column is-3 is-offset-1">
            <h2 class="title">{{ mentions.document.title }}</h2>
            <figure class="image is-3by1"></figure>
          </div>
          <div class="column is-7">
            <rich-text :elements="mentions.document.content" :is-root="true"></rich-text>
          </div>
        </div>
      </div>
    </section>

    <section class="description">
      <div class="container">
        <div class="columns">
          <div class="column is-9">
            <p v-html="description2"></p>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import RichText from '@/components/RichText.vue';
import api from '@/services/api';

export default {
  name: 'legal-notices',
  components: {
    RichText,
  },
  data() {
    return {
      mentions: null,
    };
  },
  async created() {
    await this.fetchData();
  },
  mounted() {
    document.querySelector('#form-contact').innerHTML = document.querySelector('#form').innerHTML;
  },
  watch: {
    $route: 'fetchData',
  },
  methods: {
    async fetchData() {
      this.mentions = await api.getPage('797b0922-ae11-4350-9fe1-f07b6519b02d');
    },
  },
};
</script>

<style lang='sass'>
  #legal-notices
    .container
        width: auto
        .column
          padding: 0

    .introduction
      position: relative
      margin: 0 10% 0 0
      padding: 2rem 0 10rem 0
      background-color: #ecf1f4
      &::after
        position: absolute
        content: ""
        bottom: -25px
        left: 50%
        height: 50px
        width: 4px
        background-color: #fe3904
    figure
      padding: 0
      margin: 1rem 0 3rem 0
      height: 4px
      width: 10%
      background-color: #fe3904

  @media screen and (max-width: 950px)
    #legal-notices
      .introduction
        padding: 2rem
</style>
